import { Heading, Text } from '@cleartax/wg-library-typography';
import { MARKETPLACE_PATH } from '../../../../config/constants';

export const FallBackUI = () => {
  return (
    <div className="w-full h-full flex flex-col justify-center items-center text-center">
      <img
        width="400"
        src="https://assets1.cleartax-cdn.com/cleartax/images/1657692419_4041.png"
      />
      <Heading type="h2" className={'text-grey-800'}>
        Looks like this page is unavailable!
      </Heading>
      <Text className="text-grey-500">
        Not to worry. You can head over to our{' '}
        <a
          href={MARKETPLACE_PATH}
          className="text-brand-700 cursor-pointer font-semibold"
        >
          Home page
        </a>{' '}
        or checkout our popular products.
      </Text>
    </div>
  );
};
